import React, { useEffect } from 'react';
import Footer from '@/components/Footer';
import Breadcrumbs from '@/components/Breadcrumbs';
import { SalesSectionMaxed, DetailedInfoMaxed } from '@/components/products/pre-workout-maxed';

const PreWorkoutMaxed = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 mt-4">
        <Breadcrumbs />
      </div>
      <div className="container mx-auto px-4 py-16">
        <SalesSectionMaxed />

        <div className="border-t border-border pt-12">
          <h2 className="text-3xl font-bold text-foreground text-center mb-8 font-orbit">
            Vitenskapelig dokumentasjon
          </h2>
          <p className="text-center text-muted-foreground mb-12 max-w-3xl mx-auto">
            Dykk ned i den komplette vitenskapelige analysen av hver ingrediens og hvorfor vi har valgt nøyaktig disse dosene.
          </p>
          <DetailedInfoMaxed />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PreWorkoutMaxed;
